import { render, staticRenderFns } from "./ModalCreate.vue?vue&type=template&id=35393e4c&scoped=true&"
import script from "./ModalCreate.vue?vue&type=script&lang=ts&"
export * from "./ModalCreate.vue?vue&type=script&lang=ts&"
import style0 from "./ModalCreate.vue?vue&type=style&index=0&id=35393e4c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35393e4c",
  null
  
)

export default component.exports